import { Injectable } from '@angular/core';
import { HttpClient, HttpParams  } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { QueryRequestDto, MultiResponseDto, SingleResponseDto, UserInfoDto, UserGeneralInfoDto, ChangePasswordDto, } from '@bugz-mono/shared-dtos';
import { environment } from '@bugz-mono/shared-environments'

@Injectable({
  providedIn: 'root', 
})
export class UsersApiService {

  private apiUrl= `${environment.apiUrl}/users`;
  
  constructor(private http: HttpClient) {
  }
 
  getOne(id:number) :Observable<SingleResponseDto<UserInfoDto>>{
    try {
      return this.http.get<SingleResponseDto<UserInfoDto>>(`${this.apiUrl}/getOne`,{params :{id: id}});  
    } catch (error) {
      console.log(error);
      return of( {
        success:false,
        message: 'API Error',
      });
    }
  }
  getGeneralInfo(id:number) :Observable<SingleResponseDto<UserGeneralInfoDto>>{
    try {
      return this.http.get<SingleResponseDto<UserGeneralInfoDto>>(`${this.apiUrl}/getGeneralInfo`,{params :{id: id}});  
    } catch (error) {
      console.log(error);
      return of( {
        success:false,
        message: 'API Error',
      });
    }
  }
  getAll(queryOptions?: QueryRequestDto): Observable<MultiResponseDto<UserInfoDto>> {
    let params = new HttpParams();
    if (queryOptions?.filtersJson) {
      params = params.append('filters', queryOptions.filtersJson);
    }
    if (queryOptions?.joinsJson) {
      params = params.append('joins', queryOptions.joinsJson);
    }
    if (queryOptions?.sortJson) {
      params = params.append('sort', queryOptions.sortJson);
    }
    if (queryOptions?.paginationJson) {
      params = params.append('pagination', queryOptions.paginationJson);
    }
    return this.http.get<MultiResponseDto<UserInfoDto>>(`${this.apiUrl}/getAll`, { params});  
    

  }
  getAllCustomers(idApp?:number): Observable<MultiResponseDto<any>> {
    if(idApp){
      let params = new HttpParams();
      params = params.append('idApp', idApp);
      return this.http.get<MultiResponseDto<any>>(`${this.apiUrl}/get-customers`,{ params});  
    }
    return this.http.get<MultiResponseDto<any>>(`${this.apiUrl}/get-customers`);  
    
  }
  getAllSalesAgents(): Observable<MultiResponseDto<any>> {
    return this.http.get<MultiResponseDto<any>>(`${this.apiUrl}/get-sales-agents`);  
  }
  getAllDistributors(): Observable<MultiResponseDto<any>> {
    return this.http.get<MultiResponseDto<any>>(`${this.apiUrl}/get-distributors`);  
  }
  getAllAgentRetailers(): Observable<MultiResponseDto<any>> {
    return this.http.get<MultiResponseDto<any>>(`${this.apiUrl}/get-agent-retailers`);  
  }
  createGeneralInfo(dto: UserGeneralInfoDto){
    return this.http.post<SingleResponseDto<any>>(`${this.apiUrl}/create-general`, dto)
  }
  updateGeneralInfo(dto: UserGeneralInfoDto){
    return this.http.post<SingleResponseDto<any>>(`${this.apiUrl}/update-general`, dto);
  }
  changePassword(dto: ChangePasswordDto){
    return this.http.post<SingleResponseDto<any>>(`${this.apiUrl}/change-password`,dto);  
  }
  getUserRoles(id:number){

  }
  updateUseRoles(user: UserInfoDto){
    return this.http.post<SingleResponseDto<UserInfoDto>>(`${this.apiUrl}/update-info`, user);
  }
  
  deleteCustomer(userId:number){
      return this.http.get<SingleResponseDto<any>>(`${this.apiUrl}/delete-customer`,{params :{ userId: userId }});  
  }
}